import { useState, useEffect } from 'react';
import RangeSlider from 'react-range-slider-input';

const UNIT_OPTIONS = ['px', 'rem', 'em']; // No change here, just context

export default function UnitValueSlider({ value = '', onChange, min = 0, max = 12, step = 0.005, units = UNIT_OPTIONS, defaultValue = '' }) {
  // Parse value or defaultValue into number and unit
  const parseValue = (v) => {
    const match = /^([\d.-]+)\s*(rem|em|px)?$/.exec(v) || [];
    const num = match[1] ? parseFloat(match[1]) : undefined;
    const u = match[2] || undefined;
    return { num, u };
  };

  // Use value if present, else fallback to defaultValue
  const initial = value ? parseValue(value) : parseValue(defaultValue);
  const initialNumber = typeof initial.num === 'number' && !isNaN(initial.num) ? initial.num : min;
  const initialUnit = initial.u || units[0];

  const [number, setNumber] = useState(initialNumber);
  const [unit, setUnit] = useState(initialUnit);

  useEffect(() => {
    const v = value ? value : defaultValue;
    const { num, u } = parseValue(v);
    setNumber(typeof num === 'number' && !isNaN(num) ? num : min);
    setUnit(u || units[0]);
  }, [value, defaultValue, min, units]);

  const handleValueChange = (newNumber, newUnit) => {
    setNumber(newNumber);
    setUnit(newUnit);
    onChange({ target: { value: `${newNumber}${newUnit}` } });
  };

  return (
    <div className="d-flex align-items-center gap-2 w-100">
      <RangeSlider
        className="single-thumb"
        thumbsDisabled={[true, false]}
        rangeSlideDisabled
        min={min}
        max={max}
        step={step}
        value={[min, number]}
        onInput={(val) => handleValueChange(val[1], unit)}
      />
      <input
        type="number"
        min={min}
        max={max}
        step={step}
        value={number}
        onChange={(e) => handleValueChange(Number(e.target.value), unit)}
        className="form-control"
        style={{ width: 80 }}
      />
      <select value={unit} onChange={(e) => handleValueChange(number, e.target.value)} className="form-select" style={{ width: 70 }}>
        {units.map((u) => (
          <option key={u} value={u}>
            {u}
          </option>
        ))}
      </select>
    </div>
  );
}
